import script from "./SemanticHTMLEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SemanticHTMLEditor.vue?vue&type=script&setup=true&lang=ts"

import "./SemanticHTMLEditor.vue?vue&type=style&index=0&id=4b5dfa66&lang=css"

const __exports__ = script;

export default __exports__